import { render, staticRenderFns } from "./FinancialRevenue.vue?vue&type=template&id=2bb5a2c6&scoped=true"
import script from "./FinancialRevenue.vue?vue&type=script&lang=js"
export * from "./FinancialRevenue.vue?vue&type=script&lang=js"
import style0 from "./FinancialRevenue.vue?vue&type=style&index=0&id=2bb5a2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5a2c6",
  null
  
)

export default component.exports